"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flipSortOrder = void 0;
var SortOrder_1 = require("../../types/enums/SortOrder");
function flipSortOrder(sortOrder) {
    return sortOrder === SortOrder_1.SortOrder.Asc ? SortOrder_1.SortOrder.Desc : SortOrder_1.SortOrder.Asc;
}
exports.flipSortOrder = flipSortOrder;
